module.exports = __webpack_public_path__ + "img/chemical_engineering_splash.24075103.jpg";